module.exports = __webpack_public_path__ + "img/honor1.6e0b239f.jpg";